// ========================================
// Program View - Calendar Logic
// ========================================

Object.assign(ProgramView, {
    // Same rule as the server (/api/programming/classes): only admin and coordination save classes.
    canScheduleClasses() {
        return ['admin', 'coordinator'].includes(AuthManager.getCurrentUser()?.role);
    },

    renderCalendar() {
        const grid = document.getElementById('calendar-grid');
        if (!grid) return;

        // Only what is on screen is in memory: this formation's course (hours, calendar)
        // and this month for every formation (busy rooms, professor clashes).
        if (typeof FileStorage !== 'undefined' && FileStorage.needClasses) {
            const redraw = () => { this.initializeVisibleSubjects(); this.renderCalendar(); };
            const block = FileStorage.classBlock(this.currentMonth);
            if (this.currentFormation?.id) FileStorage.needClasses({ ...FileStorage.classBlockRange(block), formationId: this.currentFormation.id }, redraw);
            const y = this.currentMonth.getFullYear(), m = this.currentMonth.getMonth();
            FileStorage.needClasses(new Date(y, m, 1), new Date(y, m + 1, 0), redraw);
        }

        // Update container class for assignment mode cursor
        if (this.selectedSubjectId) {
            grid.classList.add('assignment-mode');
        } else {
            grid.classList.remove('assignment-mode');
        }

        // Diseño A2: aviso encima del calendario mientras se ponen días a una asignatura.
        const picking = document.getElementById('pg-picking');
        if (picking) {
            const picked = this.selectedSubjectId ? DataManager.getSubject(this.selectedSubjectId) : null;
            picking.hidden = !picked;
            SafeHTML.set(picking, picked ? `<span class="pg-picking-dot" style="background: ${this.getColorForSubject(picked.id)};"></span><span>Pulsa los días para poner <b>${Utils.sanitizeHTML(picked.name)}</b>. Vuelve a pulsar la asignatura para terminar.</span>` : '');
        }

        const year = this.currentMonth.getFullYear();
        const month = this.currentMonth.getMonth();

        // Update month display
        const monthNames = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
            'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

        document.getElementById('current-month').textContent = `${monthNames[month].toUpperCase()} ${year} `;

        // Sync the academic year <select> with whatever month we navigated to
        // (prev/next arrows can drift into a year the selector's options
        // weren't built for) — rebuild the option list so it always includes
        // the current one, rather than just overwriting innerHTML like the
        // old plain-text badge used to.
        const badge = document.getElementById('program-academic-year-badge');
        if (badge) {
            SafeHTML.set(badge, this.renderAcademicYearOptions());
        }

        // Auto-heal sessions in current month that were created without classroom
        // but whose subject already has an assigned base classroom
        const currentMonthPrefix = `${year}-${String(month + 1).padStart(2, '0')}`;
        if (this.currentFormation) {
            const formationClasses = DataManager.getClassesByFormation(this.currentFormation.id)
                .filter(c => c.startDate && c.startDate.startsWith(currentMonthPrefix));
            formationClasses.forEach(c => {
                if (!c.classroom || c.classroom.trim() === '') {
                    const base = this.getSubjectBaseClassroom(c.subjectId, c.formationId, currentMonthPrefix);
                    if (base) {
                        c.classroom = base;
                        // Shown to everyone; saved only by those allowed to schedule classes.
                        if (this.canScheduleClasses()) DataManager.updateClass(c.id, { classroom: base });
                    }
                }
            });
        }

        // Get first and last day of month
        const firstDay = new Date(year, month, 1);
        const lastDay = new Date(year, month + 1, 0);
        const daysInMonth = lastDay.getDate();
        let startDayOfWeek = firstDay.getDay();

        // Adjust for Monday start (0 = Monday, 6 = Sunday)
        startDayOfWeek = startDayOfWeek === 0 ? 6 : startDayOfWeek - 1;

        let html = '';

        // Day headers
        ['L', 'M', 'X', 'J', 'V', 'S', 'D'].forEach(day => {
            html += `<div class="calendar-day-header">${day}</div>`;
        });

        // Empty cells before first day
        for (let i = 0; i < startDayOfWeek; i++) {
            html += '<div class="calendar-day empty"></div>';
        }

        const globalSettings = DataManager.getAll(DataManager.KEYS.GLOBAL_SETTINGS)[0] || { holidays: [] };
        const holidays = globalSettings.holidays || [];

        // Days of month
        for (let day = 1; day <= daysInMonth; day++) {
            const classes = this.getClassesForDay(year, month, day);
            const dateStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
            const isHoliday = holidays.includes(dateStr);

            // Replaced logic: Use exact subject color or holiday color
            let cellStyle = '';
            let title = '';

            if (classes.length > 0) {
                const uniqueSubjects = [...new Set(classes.map(c => c.subjectId))];

                if (uniqueSubjects.length === 1) {
                    const subjectId = uniqueSubjects[0];
                    // FIX: Prefer the class-specific color (schedule color) over the global subject color
                    const classInstance = classes[0];
                    const color = classInstance.color || this.subjectColors[subjectId] || '#cbd5e1';
                    cellStyle = `background-color: ${color}; color: #fff; border-color: ${color};`;
                } else {
                    // FIX: Use colors from the CLASSES, not just unique subjects map
                    // This handles same subject with different schedules (different colors)
                    const colors = classes.map(c => c.color || this.subjectColors[c.subjectId] || '#cbd5e1');

                    const percent = 100 / colors.length;
                    const gradientStops = colors.map((c, i) => {
                        return `${c} ${i * percent}%, ${c} ${(i + 1) * percent}%`;
                    }).join(', ');

                    cellStyle = `background: linear-gradient(to right, ${gradientStops}); color: #fff; border-color: transparent; text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);`;
                }

                title = `${classes.length} clase${classes.length !== 1 ? 's' : ''}`;
                if (isHoliday) title += ' (Festivo)';
            } else if (isHoliday) {
                cellStyle = `background-color: #EF4444!important; color: #fff!important; border-color: #EF4444!important;`;
                title = 'Festivo';
            }

            const isToday = new Date().toDateString() === new Date(year, month, day).toDateString();
            const todayClass = isToday ? 'today' : '';

            const hasClassClass = classes.length > 0 ? 'has-class' : '';
            const holidayClass = isHoliday ? 'is-holiday' : '';
            const weekendClass = [0, 6].includes(new Date(year, month, day).getDay()) ? 'is-weekend' : '';

            const hasSelectedSubject = this.selectedSubjectId && classes.some(c => String(c.subjectId) === String(this.selectedSubjectId));
            const selectedClass = hasSelectedSubject ? 'selected-subject-day' : '';

            const onClickFn = this.selectedSubjectId
                ? () => ProgramView.assignSubjectToDay(year, month, day)
                : () => ProgramView.showDayDetails(year, month, day);

            html += `
                <div class="calendar-day ${hasClassClass} ${selectedClass} ${holidayClass} ${weekendClass} ${todayClass}" 
                     style="${cellStyle}" 
                     data-day="${day}" data-month="${month}" data-year="${year}"
                     ${UIEvents.attr("click", onClickFn)}
                     title="${Utils.sanitizeHTML(title)}">
                    <span class="day-number">${day}</span>
                    ${hasSelectedSubject ? '<div class="day-marker"></div>' : ''}
                </div>
            `;
        }

        SafeHTML.set(grid, html);

        // Dynamic re-rendering of dependent components
        this.renderSubjects();
        this.renderExtraSessions();
        this.updateSummary();
        this.updateLoadStatus();
        // Asistente: a proposal not yet saved shows on the month (js/modules/ai-assistant.js).
        if (typeof AIAssistant !== 'undefined') AIAssistant.decorateProgram?.(this);
    },

    getSubjectBaseClassroom(subjectId, formationId = null, monthPrefix = null) {
        if (!subjectId) return '';
        const subject = DataManager.getSubject(subjectId);
        if (!subject) return '';

        // 1. Aula base guardada directamente en la asignatura
        if (subject.classroom && subject.classroom.trim() !== '') {
            return subject.classroom.trim();
        }

        const effectiveFormationId = formationId || (this.currentFormation ? this.currentFormation.id : null);
        const allClasses = DataManager.getAll(DataManager.KEYS.CLASSES) || [];

        // 2. Sesiones previas de esta misma asignatura en la misma formación y mes
        if (effectiveFormationId && monthPrefix) {
            const sameMonthClasses = allClasses.filter(c =>
                String(c.subjectId) === String(subjectId) &&
                String(c.formationId) === String(effectiveFormationId) &&
                c.startDate && c.startDate.startsWith(monthPrefix) &&
                c.classroom && c.classroom.trim() !== ''
            );
            if (sameMonthClasses.length > 0) {
                return sameMonthClasses[sameMonthClasses.length - 1].classroom.trim();
            }
        }

        // 3. Sesiones de esta asignatura en la misma formación (cualquier mes)
        if (effectiveFormationId) {
            const sameFormationClasses = allClasses.filter(c =>
                String(c.subjectId) === String(subjectId) &&
                String(c.formationId) === String(effectiveFormationId) &&
                c.classroom && c.classroom.trim() !== ''
            );
            if (sameFormationClasses.length > 0) {
                return sameFormationClasses[sameFormationClasses.length - 1].classroom.trim();
            }
        }

        // 4. Cualquier sesión de esta asignatura en el sistema
        const anySubjectClasses = allClasses.filter(c =>
            String(c.subjectId) === String(subjectId) &&
            c.classroom && c.classroom.trim() !== ''
        );
        if (anySubjectClasses.length > 0) {
            return anySubjectClasses[anySubjectClasses.length - 1].classroom.trim();
        }

        // 5. Para asignaturas comunes (COMÚN, PRACT, EXT), buscar en formaciones hermanas con el mismo nombre
        if (['COMÚN', 'PRACT', 'EXT'].includes(subject.type)) {
            const sisterSubjects = (DataManager.getAll(DataManager.KEYS.SUBJECTS) || []).filter(s =>
                s.id !== subject.id &&
                s.name && subject.name &&
                s.name.trim().toLowerCase() === subject.name.trim().toLowerCase()
            );
            for (const sister of sisterSubjects) {
                if (sister.classroom && sister.classroom.trim() !== '') {
                    return sister.classroom.trim();
                }
                const sisterClasses = allClasses.filter(c =>
                    String(c.subjectId) === String(sister.id) &&
                    c.classroom && c.classroom.trim() !== ''
                );
                if (sisterClasses.length > 0) {
                    return sisterClasses[sisterClasses.length - 1].classroom.trim();
                }
            }
        }

        return '';
    },

    assignSubjectToDay(year, month, day) {
        console.log('[DEBUG] assignSubjectToDay called:', { year, month, day, selected: this.selectedSubjectId });
        if (!this.selectedSubjectId || !this.currentFormation) {
            console.warn('[DEBUG] Assignment cancelled: No subject or formation selected');
            return;
        }

        const date = new Date(year, month, day);
        const localDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
        const dateString = localDate.toISOString().split('T')[0];

        let dayOfWeek = date.getDay();
        dayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

        const subject = DataManager.getSubject(this.selectedSubjectId);
        if (!subject) {
            console.error('[DEBUG] Subject not found:', this.selectedSubjectId);
            return;
        }

        // --- MULTI-SCHEDULE LOGIC START ---
        // Determine Start, End, and Color based on Selected Schedule Instance
        let startTime = subject.defaultStartTime || (this.currentFormation.defaultStartTime) || '09:00';
        let endTime = subject.defaultEndTime || (this.currentFormation.defaultEndTime) || '14:00';
        let colorOverride = null; // Default to subject global color

        // Find the specific selected instance to get its schedule choice
        if (this.selectedInstanceId) {
            const selectedInstance = this.visibleSubjects.find(i => String(i.instanceId) === String(this.selectedInstanceId));
            if (selectedInstance && selectedInstance.scheduleId && subject.schedules) {
                const sched = subject.schedules.find(s => s.id === selectedInstance.scheduleId);
                if (sched) {
                    startTime = sched.startTime;
                    endTime = sched.endTime;
                    colorOverride = sched.color; // This will flow into creating the class
                }
            }
        }
        // --- MULTI-SCHEDULE LOGIC END ---

        // FILTER by startTime to allow multiple schedules (Morning vs Afternoon) to coexist
        const existingClasses = DataManager.getClassesByFormation(this.currentFormation.id)
            .filter(c => c.subjectId === this.selectedSubjectId && c.startDate === dateString && c.startTime === startTime);

        if (existingClasses.length > 0) {
            if (['COMÚN', 'PRACT', 'EXT'].includes(subject.type)) {
                const otherFormations = DataManager.getFormations().filter(f => f.id !== this.currentFormation.id);
                // ... (Linking logic unchanged)
                const linkedClasses = [];
                otherFormations.forEach(f => {
                    const fClasses = DataManager.getClassesByFormation(f.id).filter(c => c.startDate === dateString);
                    fClasses.forEach(c => {
                        const cSubject = DataManager.getSubject(c.subjectId);
                        // Filter by startTime too, to only delete the same 'shift'
                        if (cSubject && cSubject.name.trim().toLowerCase() === subject.name.trim().toLowerCase() && c.startTime === startTime) {
                            linkedClasses.push({ formation: f, classSession: c, subject: cSubject });
                        }
                    });
                });

                if (linkedClasses.length > 0) {
                    this.promptForCommonClassDeletion(subject, existingClasses, linkedClasses);
                    return;
                }
            }
            existingClasses.forEach(c => DataManager.deleteClass(c.id));
            Utils.showToast('Clase eliminada', 'info');
        } else {
            const conflict = DataManager.checkProfessorConflict(
                subject.professorId, dayOfWeek, startTime, endTime, dateString
            );

            if (conflict.conflict) {
                Utils.showToast(conflict.message, 'error');
                return;
            }

            // Determinar aula base: de la asignatura o de sesiones ya asignadas en el mes
            const baseClassroom = this.getSubjectBaseClassroom(
                this.selectedSubjectId,
                this.currentFormation ? this.currentFormation.id : null,
                dateString.substring(0, 7)
            );

            // Si se detectó aula base y la asignatura aún no la tenía guardada como propiedad, persistirla
            if (baseClassroom && !subject.classroom) {
                DataManager.updateSubject(subject.id, { classroom: baseClassroom });
            }

            const newClass = {
                subjectId: this.selectedSubjectId,
                formationId: this.currentFormation.id,
                professorId: subject.professorId,
                dayOfWeek: dayOfWeek,
                startTime: startTime,
                endTime: endTime,
                classroom: baseClassroom,
                startDate: dateString,
                endDate: dateString,
                color: colorOverride // IMPORTANT: Save the specific color of this schedule
            };

            const isCommonType = ['COMÚN', 'PRACT', 'EXT'].includes(subject.type);
            const otherSameYearFormations = isCommonType ? DataManager.getFormations().filter(f =>
                f.id !== this.currentFormation.id &&
                f.academicYear === this.currentFormation.academicYear
            ) : [];
            const allOtherFormations = isCommonType ? DataManager.getFormations().filter(f => f.id !== this.currentFormation.id) : [];

            if (isCommonType && (otherSameYearFormations.length > 0 || allOtherFormations.length > 0)) {
                // Guardar asignación pendiente. NO crear la clase todavía en la base de datos:
                // Si el usuario pulsa fuera del pop-up, cierra con la 'X' o cancela, no se asigna nada.
                this.pendingCommonAssignment = {
                    subject,
                    classData: newClass,
                    formations: otherSameYearFormations,
                    allFormations: allOtherFormations
                };
                this.promptForCommonSubjectAssignment(subject, newClass, otherSameYearFormations, allOtherFormations);
                return;
            }

            DataManager.createClass(newClass);
            Utils.showToast('Clase asignada', 'success');
        }

        this.updateLoadStatus();
        this.renderCalendar();
    },

    cancelCommonAssignment() {
        this.pendingCommonAssignment = null;
        Utils.closeModal();
    },

    confirmLocalAssignmentOnly() {
        if (this.pendingCommonAssignment && this.pendingCommonAssignment.classData) {
            DataManager.createClass(this.pendingCommonAssignment.classData);
            Utils.showToast('Clase asignada solo en este curso', 'success');
            this.pendingCommonAssignment = null;
        }
        Utils.closeModal();
        if (typeof this.updateLoadStatus === 'function') this.updateLoadStatus();
        if (typeof this.renderCalendar === 'function') this.renderCalendar();
    },

    toggleAllCommonFormations(btn) {
        const checkboxes = document.querySelectorAll('.common-formation-check');
        const allChecked = Array.from(checkboxes).every(cb => cb.checked);
        checkboxes.forEach(cb => { cb.checked = !allChecked; });
        if (btn) {
            btn.textContent = allChecked ? 'Seleccionar todas' : 'Deseleccionar todas';
        }
    },

    updateToggleCommonBtn() {
        const btn = document.querySelector('.cam-link-btn');
        const checkboxes = document.querySelectorAll('.common-formation-check');
        if (!btn || checkboxes.length === 0) return;
        const allChecked = Array.from(checkboxes).every(cb => cb.checked);
        btn.textContent = allChecked ? 'Deseleccionar todas' : 'Seleccionar todas';
    },

    promptForCommonSubjectAssignment(subject, sourceClass, cachedFormations, cachedAllFormations) {
        const formations = cachedFormations || DataManager.getFormations().filter(f =>
            f.id !== this.currentFormation.id &&
            f.academicYear === this.currentFormation.academicYear
        );

        // Get all formations for the dropdown (excluding current)
        const allFormations = cachedAllFormations || DataManager.getFormations().filter(f => f.id !== this.currentFormation.id);

        if (formations.length === 0 && allFormations.length === 0) return;

        // Preseleccionar de base las formaciones de la misma línea (mismo tipo). Los tipos de un
        // solo curso (Plan de Estudios → Tipos, p. ej. un máster) son independientes entre sí y
        // no suelen compartir asignaturas, así que no se preseleccionan.
        const currentType = this.currentFormation.type || '';
        const isPreselected = (f) => {
            const targetType = f.type || '';
            if (FormationTypeService.years(currentType).length <= 1 || FormationTypeService.years(targetType).length <= 1) return false;
            return Boolean(currentType && targetType && currentType === targetType);
        };

        const allPreselected = formations.length > 0 && formations.every(f => isPreselected(f));

        const content = `
            <div class="dnr-proposal common-assignment-modal-dnr">
                ${formations.length > 0 ? `
                    <div class="cam-section">
                        <div class="cam-section-head">
                            <label class="cam-label">
                                <i class="fas fa-graduation-cap"></i> Formaciones del mismo curso (${this.currentFormation.academicYear}º)
                            </label>
                            <button type="button" class="cam-link-btn" ${UIEvents.attr("click", function(event,captured){ProgramView.toggleAllCommonFormations(this);}, [])}>
                                ${allPreselected ? 'Deseleccionar todas' : 'Seleccionar todas'}
                            </button>
                        </div>
                        <div class="cam-formation-list">
                            ${formations.map(f => {
                                const checked = isPreselected(f);
                                return `
                                <label class="cam-formation-row">
                                    <input type="checkbox" class="common-formation-check cam-checkbox" value="${Utils.sanitizeHTML(f.id)}" ${checked ? 'checked' : ''} ${UIEvents.attr("change", function(event,captured){ProgramView.updateToggleCommonBtn();}, [])}>
                                    <div class="cam-formation-info">
                                        <span class="cam-formation-name">${Utils.sanitizeHTML(f.name)}</span>
                                        <span class="cam-formation-tag">${Utils.sanitizeHTML(f.type || 'Formación')} · ${f.academicYear}º</span>
                                    </div>
                                </label>
                            `;
                            }).join('')}
                        </div>
                    </div>
                ` : ''}

                ${allFormations.length > 0 ? `
                    <div class="cam-section" style="margin-top: 1.15rem;">
                        <label class="cam-label" style="margin-bottom: 0.45rem;">
                            <i class="fas fa-sliders"></i> Asignación especial (todas las formaciones)
                        </label>
                        <div class="cam-select-box">
                            <select id="special-formation-select" class="cam-select">
                                <option value="">-- Seleccionar formación adicional --</option>
                                ${allFormations.map(f => `
                                    <option value="${Utils.sanitizeHTML(f.id)}">${Utils.sanitizeHTML(f.name)} (${Utils.sanitizeHTML(f.type || '')} · ${f.academicYear}º)</option>
                                `).join('')}
                            </select>
                            <i class="fas fa-chevron-down cam-select-arrow"></i>
                        </div>
                        <div class="cam-hint">
                            <i class="fas fa-info-circle"></i> Usa este selector para asignar a formaciones de otros cursos
                        </div>
                    </div>
                ` : ''}

                <div class="cam-actions">
                    <button type="button" class="btn btn-secondary cam-btn-cancel" ${UIEvents.attr("click", function(event,captured){ProgramView.cancelCommonAssignment();}, [])} style="margin-right: auto;">
                        Cancelar
                    </button>
                    <button type="button" class="btn btn-secondary cam-btn-secondary" ${UIEvents.attr("click", function(event,captured){ProgramView.confirmLocalAssignmentOnly();}, [])}>
                        No, solo aquí
                    </button>
                    <button type="button" class="btn btn-primary cam-btn-primary" ${UIEvents.attr("click", function(event,captured){ProgramView.handleCommonAssignment(String(captured[0]),String(captured[1]),String(captured[2]),String(captured[3]),captured[4]);}, [subject.id, sourceClass.startDate, sourceClass.startTime, sourceClass.endTime, sourceClass.dayOfWeek])}>
                        <i class="fas fa-check-double"></i> Asignar a seleccionadas
                    </button>
                </div>
            </div>
        `;

        Utils.openModal('Asignatura Compartida', content);
    },

    handleCommonAssignment(sourceSubjectId, date, startTime, endTime, dayOfWeek) {
        // 1. Confirmar y crear la clase en el curso actual
        if (this.pendingCommonAssignment && this.pendingCommonAssignment.classData) {
            DataManager.createClass(this.pendingCommonAssignment.classData);
            this.pendingCommonAssignment = null;
        } else {
            const existingLocal = DataManager.getClassesByFormation(this.currentFormation.id)
                .find(c => c.subjectId === sourceSubjectId && c.startDate === date && c.startTime === startTime);
            if (!existingLocal) {
                const sourceSub = DataManager.getSubject(sourceSubjectId);
                const baseClassroom = this.getSubjectBaseClassroom(sourceSubjectId, this.currentFormation ? this.currentFormation.id : null, date.substring(0, 7));
                DataManager.createClass({
                    subjectId: sourceSubjectId,
                    formationId: this.currentFormation.id,
                    professorId: sourceSub ? sourceSub.professorId : null,
                    dayOfWeek: dayOfWeek,
                    startTime: startTime,
                    endTime: endTime,
                    classroom: baseClassroom,
                    startDate: date,
                    endDate: date
                });
            }
        }

        // 2. Obtener formaciones seleccionadas para asignar
        const selectedFormations = Array.from(document.querySelectorAll('.common-formation-check:checked')).map(cb => cb.value);

        // Formación especial seleccionada del desplegable
        const specialSelect = document.getElementById('special-formation-select');
        if (specialSelect && specialSelect.value) {
            selectedFormations.push(specialSelect.value);
        }

        const sourceSubject = DataManager.getSubject(sourceSubjectId);

        if (!sourceSubject) {
            Utils.closeModal();
            return;
        }

        if (!selectedFormations.length) {
            Utils.closeModal();
            Utils.showToast('Clase asignada solo en este curso', 'success');
            if (typeof this.updateLoadStatus === 'function') this.updateLoadStatus();
            if (typeof this.renderCalendar === 'function') this.renderCalendar();
            return;
        }

        let assignedCount = 0;
        let skippedCount = 0;

        selectedFormations.forEach(formationId => {
            // Find equivalent subject in target formation (by name)
            const targetSubjects = DataManager.getSubjectsByFormation(formationId);
            let targetSubject = targetSubjects.find(s => s.name.trim().toLowerCase() === sourceSubject.name.trim().toLowerCase());
            let createdSubject = false;

            // If subject doesn't exist, CREATE IT (Clone)
            if (!targetSubject) {
                // Ensure we get the actual color being displayed, even if it was auto-generated
                const activeColor = sourceSubject.color || this.getColorForSubject(sourceSubject.id);

                const newSubjectData = {
                    name: sourceSubject.name,
                    formationId: formationId,
                    professorId: sourceSubject.professorId,
                    color: activeColor, // Force persistence of the active color
                    description: sourceSubject.description,
                    defaultStartTime: sourceSubject.defaultStartTime,
                    defaultEndTime: sourceSubject.defaultEndTime,
                    type: sourceSubject.type, // Should be 'COMÚN'
                    totalHours: sourceSubject.totalHours || 0,
                    studyBlock: sourceSubject.studyBlock || 'OTROS'
                };

                targetSubject = DataManager.createSubject(newSubjectData);
                createdSubject = true;
            }

            if (targetSubject) {
                // For Common Subject assignment, we explicitly ALLOW the conflict (shared lecture)
                // So we skip the checkProfessorConflict call here.

                const baseClassroom = this.getSubjectBaseClassroom(sourceSubjectId, this.currentFormation ? this.currentFormation.id : null, date.substring(0, 7)) || targetSubject.classroom || '';
                const newClass = {
                    subjectId: targetSubject.id,
                    formationId: formationId,
                    professorId: targetSubject.professorId,
                    dayOfWeek: dayOfWeek,
                    startTime: startTime,
                    endTime: endTime,
                    classroom: baseClassroom,
                    startDate: date,
                    endDate: date
                };
                DataManager.createClass(newClass);
                assignedCount++;
                if (createdSubject) {
                    console.log(`Created subject ${targetSubject.name} in formation ${formationId} `);
                }
            } else {
                console.error(`Failed to create / find subject for formation ${formationId}`);
                skippedCount++;
            }
        });

        Utils.closeModal();

        let msg = `Asignado a ${assignedCount} formaciones extra.`;
        if (skippedCount > 0) msg += ` (${skippedCount} omitidas por conflicto o falta de asignatura)`;
        Utils.showToast(msg, assignedCount > 0 ? 'success' : 'warning');
        if (typeof this.updateLoadStatus === 'function') this.updateLoadStatus();
        if (typeof this.renderCalendar === 'function') this.renderCalendar();
    },

    promptForCommonClassDeletion(subject, localClasses, linkedClasses) {
        const content = `
            <div class="dnr-proposal common-assignment-modal-dnr">
                <div class="cam-callout cam-callout-danger">
                    <div class="cam-callout-icon">
                        <i class="fas fa-trash-alt"></i>
                    </div>
                    <div class="cam-callout-body">
                        <div class="cam-callout-title">
                            Estás eliminando una clase de <strong>${Utils.sanitizeHTML(subject.name)}</strong>
                            <span class="cam-type-pill" style="background: rgba(214, 72, 60, 0.15); color: #B91C1C;">${Utils.sanitizeHTML(subject.type || 'COMÚN')}</span>
                        </div>
                        <div class="cam-callout-desc">
                            Se han encontrado clases coincidentes en otras formaciones para este día. ¿Deseas eliminarlas también?
                        </div>
                    </div>
                </div>

                <div class="cam-section">
                    <div class="cam-section-head">
                        <label class="cam-label">
                            <i class="fas fa-link"></i> Formaciones vinculadas
                        </label>
                    </div>
                    <div class="cam-formation-list">
                        ${linkedClasses.map(link => `
                            <label class="cam-formation-row">
                                <input type="checkbox" class="common-deletion-check cam-checkbox" value="${Utils.sanitizeHTML(link.classSession.id)}" checked>
                                <div class="cam-formation-info">
                                    <span class="cam-formation-name">${Utils.sanitizeHTML(link.formation.name)}</span>
                                    <span class="cam-formation-tag">${Utils.sanitizeHTML(link.classSession.startTime)}-${Utils.sanitizeHTML(link.classSession.endTime)}</span>
                                </div>
                            </label>
                        `).join('')}
                    </div>
                </div>

                <div class="cam-actions">
                    <button type="button" class="btn btn-secondary cam-btn-secondary" ${UIEvents.attr("click", function(event,captured){ProgramView.handleCommonDeletionExec(String(captured[0]),false);}, [localClasses.map(c => c.id).join(',')])}>
                        No, solo aquí
                    </button>
                    <button type="button" class="btn btn-danger cam-btn-danger" ${UIEvents.attr("click", function(event,captured){ProgramView.handleCommonDeletionExec(String(captured[0]),true);}, [localClasses.map(c => c.id).join(',')])}>
                        <i class="fas fa-trash-alt"></i> Eliminar seleccionadas
                    </button>
                </div>
            </div>
        `;

        Utils.openModal('Eliminar Clase Compartida', content);
    },

    handleCommonDeletionExec(localClassIdsStr, deleteLinked) {
        const localClassIds = localClassIdsStr.split(',');

        // Always delete local
        localClassIds.forEach(id => DataManager.deleteClass(id));
        let msg = 'Clase eliminada localmente';

        if (deleteLinked) {
            const selectedLinkedIds = Array.from(document.querySelectorAll('.common-deletion-check:checked')).map(cb => cb.value);
            selectedLinkedIds.forEach(id => DataManager.deleteClass(id));
            if (selectedLinkedIds.length > 0) {
                msg += ` y de ${selectedLinkedIds.length} formaciones más.`;
            }
        }

        Utils.closeModal();
        Utils.showToast(msg, 'info');
        this.updateLoadStatus();
        this.renderCalendar();
    },

    getClassesForDay(year, month, day) {
        if (!this.currentFormation) return [];

        let classes = DataManager.getClassesByFormation(this.currentFormation.id);
        if (AuthManager.isProfessor() && !AuthManager.hasModule('plan-estudios')) {
            const professorId = AuthManager.getProfessorId();
            classes = classes.filter(c => c.professorId === professorId);
        }
        const targetDate = new Date(year, month, day);
        // Fix for timezones (local vs UTC) - ensure we map strictly to YYYY-MM-DD
        const monthStr = String(month + 1).padStart(2, '0');
        const dayStr = String(day).padStart(2, '0');
        const dateString = `${year}-${monthStr}-${dayStr}`;

        return classes.filter(cls => {
            if (cls.startDate) {
                const start = cls.startDate;
                const end = cls.endDate || cls.startDate;
                return dateString >= start && dateString <= end;
            }
            return false;
        });
    },

    showDayDetails(year, month, day) {
        const date = new Date(year, month, day);
        const dayClasses = this.getClassesForDay(year, month, day);

        const dayNames = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
        const monthNames = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
            'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

        const monthStr = String(month + 1).padStart(2, '0');
        const dayStr2 = String(day).padStart(2, '0');
        const dateString = `${year}-${monthStr}-${dayStr2}`;
        const isStudent = AuthManager.isStudent() || !AuthManager.canManageModule('plan-estudios');

        const dateBadge = `${dayNames[date.getDay()]} ${day} ${monthNames[month].substring(0, 3)}. ${year}`.toUpperCase();

        let content = `
            <div class="dnr-proposal day-details-modal-dnr">
                <div class="dd-header">
                    <div class="dd-title-block">
                        <span class="dd-date-pill">
                            <i class="far fa-calendar-alt"></i> ${dateBadge}
                        </span>
                        <span class="dd-count-label">
                            ${dayClasses.length} ${dayClasses.length === 1 ? 'sesión' : 'sesiones'}
                        </span>
                    </div>
                    <button type="button" class="dd-map-btn" ${UIEvents.attr("click", function(event,captured){ProgramView.openDayMapModal(String(captured[0]));}, [dateString])}>
                        <i class="fas fa-map-marked-alt"></i> Ocupación de Aulas
                    </button>
                </div>
        `;

        if (dayClasses.length === 0) {
            content += `
                <div class="dnr-empty" style="padding: 3rem 1.5rem; text-align: center; background: var(--dnr-surface-sunken); border: 1px dashed var(--dnr-line); border-radius: var(--dnr-r-sm, 10px);">
                    <i class="far fa-calendar-times" style="font-size: 2.2rem; color: var(--dnr-ink-faint); margin-bottom: 0.6rem; display: block;"></i>
                    <div style="font-weight: 700; font-size: 1rem; color: var(--dnr-ink); margin-bottom: 2px;">No hay clases programadas</div>
                    <div style="font-size: 0.82rem; color: var(--dnr-ink-mute);">No se encontraron sesiones asignadas para este día.</div>
                </div>
            `;
        } else {
            content += '<div class="dd-card-list">';

            dayClasses.forEach(cls => {
                const subject = DataManager.getSubject(cls.subjectId);
                const professor = subject ? DataManager.getProfessor(subject.professorId) : null;
                const color = cls.color || this.getColorForSubject(cls.subjectId, 0);

                // Auto-healing: si la sesión no tiene aula asignada pero la asignatura ya tiene un aula base
                if (!cls.classroom || cls.classroom.trim() === '') {
                    const baseClassroom = this.getSubjectBaseClassroom(cls.subjectId, cls.formationId, dateString.substring(0, 7));
                    if (baseClassroom) {
                        cls.classroom = baseClassroom;
                        if (this.canScheduleClasses()) DataManager.updateClass(cls.id, { classroom: baseClassroom });
                    }
                }

                const classroomBadgeHtml = cls.classroom
                    ? `<button type="button" class="dd-classroom-badge" ${UIEvents.attr('click', () => isStudent ? ProgramView.showClassroomInfoPopup(cls.classroom,dateString,cls.startTime,cls.endTime) : ProgramView.changeClassroomForClass(cls.id,dateString))} title="${isStudent ? 'Ver información del aula' : 'Cambiar aula solo para este día'}">
                         <i class="fas fa-door-open" style="font-size: 0.7rem;"></i> ${Utils.sanitizeHTML(cls.classroom)} <i class="fas fa-${isStudent ? 'info-circle' : 'exchange-alt'}" style="font-size: 0.6rem; opacity: 0.75;"></i>
                       </button>`
                    : (isStudent 
                        ? `<span style="font-size: 0.75rem; color: var(--dnr-ink-faint); font-style: italic;"><i class="fas fa-door-closed"></i> Sin aula</span>` 
                        : `<button type="button" class="dd-unassigned-badge" ${UIEvents.attr("click", function(event,captured){ProgramView.changeClassroomForClass(String(captured[0]),String(captured[1]));}, [cls.id, dateString])}><i class="fas fa-map-marked-alt" style="color: var(--dnr-teal-600);"></i> Asignar aula</button>`);

                const baseSchedule = this.getFormationDefaultSchedule();
                const isOutOfSchedule = !!baseSchedule &&
                    (cls.startTime !== baseSchedule.startTime || cls.endTime !== baseSchedule.endTime);

                content += `
                    <div class="dd-card" style="border-left: 5px solid ${color};">
                        <div class="dd-card-top">
                            <div style="display: flex; align-items: center; gap: 0.5rem; flex-wrap: wrap;">
                                <span class="dd-time">
                                    <i class="far fa-clock"></i>${cls.startTime} – ${cls.endTime}
                                </span>
                                ${isOutOfSchedule ? `<span class="dd-out-of-schedule" title="Horario general: ${baseSchedule.startTime} – ${baseSchedule.endTime}">Fuera de horario</span>` : ''}
                            </div>
                            <div>
                                ${classroomBadgeHtml}
                            </div>
                        </div>

                        <div>
                            <h4 class="dd-subject-name">
                                ${Utils.sanitizeHTML(subject ? subject.name : 'Asignatura')}
                            </h4>
                            ${professor ? `
                                <div class="dd-prof-info">
                                    <i class="fas fa-chalkboard-teacher"></i>
                                    <span>${Utils.sanitizeHTML(professor.firstName)} ${Utils.sanitizeHTML(professor.lastName)}</span>
                                </div>
                            ` : ''}
                        </div>

                        ${isStudent ? '' : `
                            <div class="dd-card-actions">
                                <button type="button" ${UIEvents.attr("click", function(event,captured){ProgramView.changeTimeForClass(String(captured[0]),String(captured[1]));}, [cls.id, dateString])} class="dd-btn-action">
                                    <i class="far fa-clock" style="color: var(--dnr-teal-600);"></i> Cambiar horario
                                </button>
                                <button type="button" ${UIEvents.attr("click", function(event,captured){ProgramView.deleteClass(String(captured[0]));}, [cls.id])} class="dd-btn-action dd-btn-danger">
                                    <i class="fas fa-trash-alt"></i> Eliminar
                                </button>
                            </div>
                        `}
                    </div>
                `;
            });

            content += '</div>';
        }

        content += '</div>';

        Utils.openModal('Clases del Día', content);
    },

    openDayMapModal(dateString) {
        // Load custom zones
        const rawSaved = (typeof FileStorage !== 'undefined' && FileStorage.getItem('ecpv_floorplan_zones')) || BrowserState.getItem('ecpv_floorplan_zones');
        let zones = [
            { id: 'z1', name: 'Aula 1', x: 20, y: 15, width: 12, height: 18, floor: 1 },
            { id: 'z2', name: 'Aula 2', x: 33, y: 15, width: 12, height: 18, floor: 1 },
            { id: 'z3', name: 'Aula 3', x: 46, y: 15, width: 12, height: 18, floor: 1 },
            { id: 'z4', name: 'Aula 4', x: 59, y: 15, width: 12, height: 18, floor: 1 },
            { id: 'zp', name: 'Plató Principal', x: 28, y: 38, width: 28, height: 36, floor: 1 },
            { id: 'zs', name: 'Estudio de Sonido', x: 72, y: 15, width: 13, height: 18, floor: 1 },
            { id: 'ze', name: 'Sala de Edición', x: 70, y: 48, width: 15, height: 22, floor: 1 }
        ];
        if (rawSaved) { try { zones = JSON.parse(rawSaved); } catch(e) {} }
        zones.forEach(z => { if (z && !z.floor) z.floor = 1; });

        // Get ALL classes on that date across ALL formations
        const allClasses = DataManager.getAll(DataManager.KEYS.CLASSES) || [];
        const dayClasses = allClasses.filter(c => c.startDate <= dateString && (c.endDate || c.startDate) >= dateString);

        // Build classroom → classes map
        const roomMap = {};
        dayClasses.forEach(cls => {
            if (!cls.classroom) return;
            if (!roomMap[cls.classroom]) roomMap[cls.classroom] = [];
            roomMap[cls.classroom].push(cls);
        });

        const formattedDate = (() => {
            const [y, m, d] = dateString.split('-');
            const months = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
            return `${parseInt(d)} de ${months[parseInt(m)-1]} ${y}`;
        })();

        this._dayMapPicker = {
            dateString,
            formattedDate,
            roomMap,
            zones
        };

        SafeHTML.fire({
            title: `<i class="fas fa-map-marked-alt" style="color:#3b82f6;margin-right:8px;"></i>Ocupación de Aulas · ${formattedDate}`,
            html: this._buildDayMapHtml(1),
            width: '660px',
            showConfirmButton: false,
            showCancelButton: true,
            cancelButtonText: 'Cerrar'
        });
    },

    _buildDayMapHtml(floor) {
        if (!this._dayMapPicker) return '';
        const { dateString, formattedDate, roomMap, zones } = this._dayMapPicker;
        const floorZones = zones.filter(z => (z.floor || 1) === floor);

        const roomsHtml = floorZones.map(z => {
            const occupants = roomMap[z.name] || [];
            const isOccupied = occupants.length > 0;
            const bg = isOccupied ? 'rgba(239,68,68,0.18)' : 'rgba(16,185,129,0.14)';
            const border = isOccupied ? '#ef4444' : '#10b981';
            const badgeBg = isOccupied ? '#ef4444' : '#10b981';

            // Build tooltip lines
            const tooltipLines = occupants.map(cls => {
                const subj = DataManager.getSubject(cls.subjectId);
                const form = DataManager.getFormation(cls.formationId);
                return `${subj ? subj.name : '?'} (${form ? form.name : '?'}) ${cls.startTime||''}–${cls.endTime||''}`;
            });
            const tooltip = isOccupied ? tooltipLines.join(' | ') : 'Sin clases este día';

            // Inner text: show subject+formation for each occupant
            const innerLines = occupants.slice(0,2).map(cls => {
                const subj = DataManager.getSubject(cls.subjectId);
                return `<span style="font-size:0.58rem; color:#7f1d1d; display:block; pointer-events:none; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; max-width:90%;">${Utils.sanitizeHTML(subj ? subj.name : '?')} · ${cls.startTime||''}–${cls.endTime||''}</span>`;
            }).join('');
            const moreLabel = occupants.length > 2 ? `<span style="font-size:0.55rem;color:#9f1239;pointer-events:none;">+${occupants.length-2} más</span>` : '';

            return `<div title="${Utils.sanitizeHTML(tooltip)}"
                        style="position:absolute; top:${z.y}%; left:${z.x}%; width:${z.width}%; height:${z.height}%;
                               background:${bg}; border:2px solid ${border}; border-radius:8px;
                               display:flex; flex-direction:column; justify-content:center; align-items:center;
                               padding:4px; box-sizing:border-box; text-align:center; overflow:hidden;">
                    <span style="font-weight:800; font-size:0.75rem; color:#1e293b; pointer-events:none; line-height:1.2;">${Utils.sanitizeHTML(z.name)}</span>
                    <span style="background:${badgeBg}; color:white; font-size:0.55rem; font-weight:700; padding:1px 5px; border-radius:4px; margin-top:2px; text-transform:uppercase; pointer-events:none;">
                        ${isOccupied ? 'Ocupada' : 'Libre'}
                    </span>
                    ${innerLines}${moreLabel}
                </div>`;
        }).join('');

        const bgImage = floor === 2 ? '/assets/plano_instalaciones_p2.jpg' : '/assets/plano_instalaciones.png';

        return `
            <div style="margin-bottom:0.6rem; text-align:left;">
                <div style="display:flex; align-items:center; justify-content:space-between; gap:0.75rem; flex-wrap:wrap;">
                    <div style="font-size:0.75rem; color:#64748b; display:flex; gap:1.2rem;">
                        <span><span style="display:inline-block;width:10px;height:10px;border-radius:2px;background:#10b981;margin-right:3px;vertical-align:middle;"></span>Libre ese día</span>
                        <span><span style="display:inline-block;width:10px;height:10px;border-radius:2px;background:#ef4444;margin-right:3px;vertical-align:middle;"></span>Ocupada — pasa el ratón para ver detalle</span>
                    </div>
                    <div style="display:inline-flex; border:1px solid #e2e8f0; border-radius:8px; overflow:hidden; flex-shrink:0;">
                        <button type="button" ${UIEvents.attr("click", function(event,captured){ProgramView.switchDayMapFloor(1);}, [])}
                                style="border:none; padding:5px 14px; font-size:0.75rem; font-weight:700; cursor:pointer; transition:all 0.15s; background:${floor === 1 ? '#2563eb' : 'white'}; color:${floor === 1 ? 'white' : '#64748b'};">Planta 1</button>
                        <button type="button" ${UIEvents.attr("click", function(event,captured){ProgramView.switchDayMapFloor(2);}, [])}
                                style="border:none; padding:5px 14px; font-size:0.75rem; font-weight:700; cursor:pointer; transition:all 0.15s; background:${floor === 2 ? '#2563eb' : 'white'}; color:${floor === 2 ? 'white' : '#64748b'};">Planta 2</button>
                    </div>
                </div>
            </div>
            <div style="position:relative; width:100%; aspect-ratio:1/1; border:1px solid #e2e8f0; border-radius:12px;
                         background-image:url('${bgImage}'); background-size:contain;
                         background-repeat:no-repeat; background-position:${floor === 2 ? 'top' : 'center'}; background-color:#fff;">
                ${roomsHtml || `<div style="position:absolute; inset:0; display:flex; align-items:center; justify-content:center; color:#94a3b8; font-size:0.82rem;">Sin aulas en esta planta</div>`}
            </div>
        `;
    },

    switchDayMapFloor(floor) {
        if (!this._dayMapPicker) return;
        Swal.update({ html: this._buildDayMapHtml(floor) });
    },

    getClassroomConflictsForSingleClass(classroomName, classId, dateString) {
        const conflicts = [];
        if (!classroomName) return conflicts;

        const targetClass = DataManager.getById(DataManager.KEYS.CLASSES, classId);
        if (!targetClass) return conflicts;

        const allClasses = DataManager.getAll(DataManager.KEYS.CLASSES) || [];

        // Find other classes in this classroom on this date overlapping in time
        const otherClasses = allClasses.filter(c =>
            c.classroom === classroomName &&
            c.startDate === dateString &&
            c.id !== classId
        );

        for (const oCls of otherClasses) {
            if (ConflictService.timesOverlap(targetClass.startTime, targetClass.endTime, oCls.startTime, oCls.endTime)) {
                const otherSubject = DataManager.getSubject(oCls.subjectId);
                const otherFormation = DataManager.getById(DataManager.KEYS.FORMATIONS, oCls.formationId);
                conflicts.push({
                    date: dateString,
                    startTime: oCls.startTime,
                    endTime: oCls.endTime,
                    otherClass: oCls,
                    otherSubjectName: otherSubject ? otherSubject.name : 'Asignatura',
                    otherFormationName: otherFormation ? otherFormation.name : 'Formación'
                });
            }
        }
        return conflicts;
    },

    showSingleClassroomConflictAlert(classroomName, classId, dateString) {
        const conflicts = this.getClassroomConflictsForSingleClass(classroomName, classId, dateString);
        if (conflicts.length === 0) return;

        let conflictsListHtml = conflicts.map(c => {
            const [y, m, d] = c.date.split('-');
            const dateStr = `${d}/${m}/${y}`;
            return `
                <div style="text-align: left; background: #fff5f5; border: 1px solid #feb2b2; border-radius: 8px; padding: 10px; margin-bottom: 8px; font-size: 0.85rem;">
                    <div style="font-weight: bold; color: #c53030; display: flex; align-items: center; gap: 6px;">
                        <i class="fas fa-calendar-day"></i> ${dateStr} (${c.startTime} - ${c.endTime})
                    </div>
                    <div style="color: #4a5568; margin-top: 5px;">
                        <strong>Grupo:</strong> ${c.otherFormationName}
                    </div>
                    <div style="color: #4a5568; margin-top: 2px;">
                        <strong>Asignatura:</strong> ${c.otherSubjectName}
                    </div>
                </div>
            `;
        }).join('');

        SafeHTML.fire({
            title: `<span style="color: #e53e3e; display: inline-flex; align-items: center; gap: 8px;"><i class="fas fa-exclamation-triangle"></i> Aula Ocupada</span>`,
            html: `
                <p style="text-align: left; font-size: 0.9rem; color: #4a5568; margin-bottom: 1rem; line-height: 1.4;">
                    No se puede asignar el aula <strong>${classroomName}</strong> para esta sesión porque ya está ocupada por otro grupo a esa misma hora:
                </p>
                <div>
                    ${conflictsListHtml}
                </div>
            `,
            icon: 'error',
            confirmButtonText: 'Entendido',
            confirmButtonColor: '#e53e3e'
        });
    },

    // Change the classroom for a SINGLE specific class session (not the whole month)
    changeClassroomForClass(classId, dateString) {
        const rawSaved = (typeof FileStorage !== 'undefined' && FileStorage.getItem('ecpv_floorplan_zones')) || BrowserState.getItem('ecpv_floorplan_zones');
        let zones = [
            { id: 'z1', name: 'Aula 1', x: 20, y: 15, width: 12, height: 18, floor: 1 },
            { id: 'z2', name: 'Aula 2', x: 33, y: 15, width: 12, height: 18, floor: 1 },
            { id: 'z3', name: 'Aula 3', x: 46, y: 15, width: 12, height: 18, floor: 1 },
            { id: 'z4', name: 'Aula 4', x: 59, y: 15, width: 12, height: 18, floor: 1 },
            { id: 'zp', name: 'Plató Principal', x: 28, y: 38, width: 28, height: 36, floor: 1 },
            { id: 'zs', name: 'Estudio de Sonido', x: 72, y: 15, width: 13, height: 18, floor: 1 },
            { id: 'ze', name: 'Sala de Edición', x: 70, y: 48, width: 15, height: 22, floor: 1 }
        ];
        if (rawSaved) { try { zones = JSON.parse(rawSaved); } catch(e) {} }
        zones.forEach(z => { if (z && !z.floor) z.floor = 1; });

        const formattedDate = (() => {
            const [y, m, d] = dateString.split('-');
            const months = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
            return `${parseInt(d)} de ${months[parseInt(m)-1]} ${y}`;
        })();

        const currentClass = (DataManager.getAll(DataManager.KEYS.CLASSES) || []).find(c => c.id === classId);
        const currentAssignedRoom = currentClass ? currentClass.classroom : null;
        const currentSubject = currentClass ? DataManager.getSubject(currentClass.subjectId) : null;
        const subjectName = currentSubject ? currentSubject.name : (currentClass ? currentClass.name : 'esta sesión');

        const assignedZone = currentAssignedRoom
            ? zones.find(z => z.name && z.name.trim().toLowerCase() === currentAssignedRoom.trim().toLowerCase())
            : null;
        const initialFloor = assignedZone ? (assignedZone.floor || 1) : 1;

        this._singleClassPicker = {
            classId,
            dateString,
            formattedDate,
            subjectName,
            currentAssignedRoom,
            zones
        };

        SafeHTML.fire({
            title: `<i class="fas fa-map-marked-alt" style="color:#f59e0b;margin-right:8px;"></i>Cambiar Aula · Solo ${formattedDate}`,
            html: this._buildSingleClassClassroomPickerHtml(initialFloor),
            width: '660px',
            showConfirmButton: false,
            showCancelButton: true,
            cancelButtonText: 'Cancelar'
        });
    },

    _buildSingleClassClassroomPickerHtml(floor) {
        if (!this._singleClassPicker) return '';
        const { classId, dateString, formattedDate, subjectName, currentAssignedRoom, zones } = this._singleClassPicker;

        const floorZones = zones.filter(z => (z.floor || 1) === floor);

        const roomsHtml = floorZones.map(z => {
            const isAssigned = Boolean(currentAssignedRoom && currentAssignedRoom.trim().toLowerCase() === z.name.trim().toLowerCase());
            const conflicts = this.getClassroomConflictsForSingleClass(z.name, classId, dateString);
            const isOccupied = conflicts.length > 0;

            let bg, border, badgeBg, boxShadow, hoverBg;
            if (isAssigned && !isOccupied) {
                bg = 'rgba(37, 99, 235, 0.20)';
                border = '#2563eb';
                badgeBg = '#2563eb';
                boxShadow = '0 0 0 3px rgba(37, 99, 235, 0.35), 0 4px 6px -1px rgba(0, 0, 0, 0.1)';
                hoverBg = 'rgba(37, 99, 235, 0.32)';
            } else if (isAssigned && isOccupied) {
                bg = 'rgba(239, 68, 68, 0.22)';
                border = '#dc2626';
                badgeBg = '#dc2626';
                boxShadow = '0 0 0 3px rgba(220, 38, 38, 0.35)';
                hoverBg = 'rgba(239, 68, 68, 0.35)';
            } else if (isOccupied) {
                bg = 'rgba(239, 68, 68, 0.16)';
                border = '#ef4444';
                badgeBg = '#ef4444';
                boxShadow = 'none';
                hoverBg = 'rgba(239, 68, 68, 0.28)';
            } else {
                bg = 'rgba(16, 185, 129, 0.14)';
                border = '#10b981';
                badgeBg = '#10b981';
                boxShadow = 'none';
                hoverBg = 'rgba(16, 185, 129, 0.28)';
            }

            const cursor = 'pointer';
            const hover = `${UIEvents.attr("mouseover", function(event,captured){this.style.background=String(captured[0]);this.style.transform='scale(1.03)';}, [hoverBg])} ${UIEvents.attr("mouseout", function(event,captured){this.style.background=String(captured[0]);this.style.transform='scale(1)';}, [bg])}`;
            
            const click = isOccupied 
                ? () => ProgramView.showSingleClassroomConflictAlert(z.name, classId, dateString)
                : () => ProgramView._applyClassroomToSingleClass(classId,z.name,dateString);

            const badgeText = isAssigned
                ? (isOccupied ? '<i class="fas fa-exclamation-triangle" style="margin-right:2px;"></i>Asignada' : '<i class="fas fa-check-circle" style="margin-right:2px;"></i>Asignada')
                : (isOccupied ? 'Ocupada' : 'Libre');

            const tooltipText = isAssigned
                ? (isOccupied ? `Aula asignada con conflicto: ${conflicts[0].otherFormationName} - ${conflicts[0].otherSubjectName}` : 'Aula actualmente asignada a esta sesión')
                : (isOccupied ? `Ocupada: ${conflicts[0].otherFormationName} - ${conflicts[0].otherSubjectName} (${conflicts[0].startTime}-${conflicts[0].endTime})` : 'Clic para asignar solo este día');

            return `<div ${UIEvents.attr("click", click)} ${hover}
                        title="${Utils.sanitizeHTML(tooltipText)}"
                        style="position:absolute;top:${z.y}%;left:${z.x}%;width:${z.width}%;height:${z.height}%;
                               background:${bg};border:2.5px solid ${border};border-radius:8px;
                               box-shadow:${boxShadow};
                               display:flex;flex-direction:column;justify-content:center;align-items:center;
                               cursor:${cursor};transition:all 0.2s;padding:4px;box-sizing:border-box;text-align:center;z-index:${isAssigned ? 2 : 1};">
                        <span style="font-weight:800;font-size:0.75rem;color:#1e293b;pointer-events:none;line-height:1.2;">${Utils.sanitizeHTML(z.name)}</span>
                        <span style="background:${badgeBg};color:white;font-size:0.55rem;font-weight:800;padding:1px 5px;border-radius:4px;margin-top:2px;text-transform:uppercase;pointer-events:none;display:inline-flex;align-items:center;">
                            ${badgeText}
                        </span>
                        ${isAssigned ? `<span style="font-size:0.52rem;color:${isOccupied ? '#dc2626' : '#1d4ed8'};font-weight:800;margin-top:2px;pointer-events:none;background:${isOccupied ? 'transparent' : '#dbeafe'};padding:0 3px;border-radius:3px;">Aula actual</span>` : ''}
                    </div>`;
        }).join('');

        const bgImage = floor === 2 ? '/assets/plano_instalaciones_p2.jpg' : '/assets/plano_instalaciones.png';

        return `
            <div style="margin-bottom:0.5rem;font-size:0.8rem;color:#92400e;background:#fef3c7;border:1px solid #fde68a;border-radius:8px;padding:6px 12px;text-align:center;">
                <i class="fas fa-info-circle" style="margin-right:4px;"></i>
                Solo cambia el aula de <strong>${Utils.sanitizeHTML(subjectName)}</strong> en <strong>esta sesión</strong>.
            </div>
            <div style="margin-bottom:0.6rem; text-align:left;">
                <div style="display:flex; align-items:center; justify-content:space-between; gap:0.75rem; flex-wrap:wrap;">
                    <div style="margin-top:2px; font-size:0.73rem; color:#64748b; display:flex; gap:1rem; flex-wrap:wrap; align-items:center;">
                        <span><span style="display:inline-block;width:11px;height:11px;border-radius:2px;background:#2563eb;margin-right:4px;vertical-align:middle;box-shadow:0 0 0 2px rgba(37,99,235,0.25);"></span><strong style="color:#1d4ed8;">Asignada</strong> (aula actual)</span>
                        <span><span style="display:inline-block;width:11px;height:11px;border-radius:2px;background:#10b981;margin-right:4px;vertical-align:middle;"></span>Libre</span>
                        <span><span style="display:inline-block;width:11px;height:11px;border-radius:2px;background:#ef4444;margin-right:4px;vertical-align:middle;"></span>Conflicto</span>
                    </div>
                    <div style="display:inline-flex; border:1px solid #e2e8f0; border-radius:8px; overflow:hidden; flex-shrink:0;">
                        <button type="button" ${UIEvents.attr("click", function(event,captured){ProgramView.switchSingleClassClassroomFloor(1);}, [])}
                                style="border:none; padding:5px 14px; font-size:0.75rem; font-weight:700; cursor:pointer; transition:all 0.15s; background:${floor === 1 ? '#2563eb' : 'white'}; color:${floor === 1 ? 'white' : '#64748b'};">Planta 1</button>
                        <button type="button" ${UIEvents.attr("click", function(event,captured){ProgramView.switchSingleClassClassroomFloor(2);}, [])}
                                style="border:none; padding:5px 14px; font-size:0.75rem; font-weight:700; cursor:pointer; transition:all 0.15s; background:${floor === 2 ? '#2563eb' : 'white'}; color:${floor === 2 ? 'white' : '#64748b'};">Planta 2</button>
                    </div>
                </div>
            </div>
            <div style="position:relative; width:100%; aspect-ratio:1/1; border:1px solid #e2e8f0; border-radius:12px;
                         background-image:url('${bgImage}'); background-size:contain;
                         background-repeat:no-repeat; background-position:${floor === 2 ? 'top' : 'center'}; background-color:#fff;">
                ${roomsHtml || `<div style="position:absolute; inset:0; display:flex; align-items:center; justify-content:center; color:#94a3b8; font-size:0.82rem;">Sin aulas en esta planta</div>`}
            </div>
            <div style="margin-top:0.75rem; text-align:center;">
                <button ${UIEvents.attr("click", function(event,captured){ProgramView._applyClassroomToSingleClass(String(captured[0]),'',String(captured[1]));}, [classId, dateString])}
                        style="background:none; border:1px solid #e2e8f0; border-radius:8px; padding:5px 14px; font-size:0.75rem; color:#94a3b8; cursor:pointer;">
                    <i class="fas fa-times" style="margin-right:3px;"></i>Sin aula este día
                </button>
            </div>
        `;
    },

    switchSingleClassClassroomFloor(floor) {
        if (!this._singleClassPicker) return;
        Swal.update({ html: this._buildSingleClassClassroomPickerHtml(floor) });
    },

    _applyClassroomToSingleClass(classId, classroomName, dateString) {
        Swal.close();
        
        const targetClass = DataManager.getAll(DataManager.KEYS.CLASSES).find(c => c.id === classId);
        if (targetClass) {
            // Update the selected class
            DataManager.updateClass(classId, { classroom: classroomName });
            
            // Check if this class's subject is a common/shared one to propagate the classroom change
            const subject = DataManager.getSubject(targetClass.subjectId);
            if (subject && classroomName && !subject.classroom) {
                DataManager.updateSubject(subject.id, { classroom: classroomName });
            }
            if (subject && ['COMÚN', 'PRACT', 'EXT'].includes(subject.type)) {
                const otherFormations = DataManager.getFormations().filter(f => f.id !== targetClass.formationId);
                otherFormations.forEach(f => {
                    const fClasses = DataManager.getClassesByFormation(f.id).filter(c => c.startDate === dateString);
                    fClasses.forEach(c => {
                        const cSubject = DataManager.getSubject(c.subjectId);
                        if (cSubject && 
                            cSubject.name.trim().toLowerCase() === subject.name.trim().toLowerCase() && 
                            c.startTime === targetClass.startTime) {
                            DataManager.updateClass(c.id, { classroom: classroomName });
                        }
                    });
                });
            }
        }

        Utils.showToast(
            classroomName
                ? `Aula '${classroomName}' asignada para este día`
                : 'Aula eliminada para este día',
            'success'
        );
        this.renderCalendar();
        this.renderSubjects();
        // Re-open the day detail popup so the user sees the change
        const [y, m, d] = dateString.split('-').map(Number);
        this.showDayDetails(y, m - 1, d);
    },

    /**
     * Cambia el horario de UNA sesión concreta (p.ej. una asignatura que por
     * necesidades del profesor pasa de 15:00-18:00 a 10:00-13:00 solo ese día).
     * El cambio aparece después como observación en la columna OBS. de la lista
     * de asignaturas.
     */
    changeTimeForClass(classId, dateString) {
        const targetClass = DataManager.getAll(DataManager.KEYS.CLASSES).find(c => c.id === classId);
        if (!targetClass) return;

        const subject = DataManager.getSubject(targetClass.subjectId);
        const base = this.getFormationDefaultSchedule();

        const formattedDate = (() => {
            const [y, m, d] = dateString.split('-');
            const months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
            return `${parseInt(d)} de ${months[parseInt(m) - 1]} ${y}`;
        })();

        // Clases equivalentes en otras formaciones (asignaturas compartidas)
        const linked = [];
        if (subject && ['COMÚN', 'PRACT', 'EXT'].includes(subject.type)) {
            DataManager.getFormations()
                .filter(f => f.id !== targetClass.formationId)
                .forEach(f => {
                    DataManager.getClassesByFormation(f.id)
                        .filter(c => c.startDate === dateString && c.startTime === targetClass.startTime)
                        .forEach(c => {
                            const cSubject = DataManager.getSubject(c.subjectId);
                            if (cSubject && subject && cSubject.name.trim().toLowerCase() === subject.name.trim().toLowerCase()) {
                                linked.push({ id: c.id, formationName: f.name });
                            }
                        });
                });
        }

        SafeHTML.fire({
            title: `<i class="fas fa-clock" style="color:#f59e0b;margin-right:8px;"></i>Cambiar Horario · Solo ${formattedDate}`,
            html: `
                <div style="margin-bottom:0.75rem;font-size:0.8rem;color:#92400e;background:#fef3c7;border:1px solid #fde68a;border-radius:8px;padding:6px 12px;text-align:center;">
                    <i class="fas fa-info-circle" style="margin-right:4px;"></i>
                    Solo cambia el horario de <strong>esta sesión</strong>. El resto del mes no se modifica.
                </div>
                <p style="font-size:0.85rem;color:#475569;margin:0 0 0.75rem;">
                    <strong>${subject ? Utils.sanitizeHTML(subject.name) : 'Asignatura'}</strong>
                    ${base ? `<br><span style="font-size:0.75rem;color:#94a3b8;">Horario general de la formación: ${base.startTime} - ${base.endTime}</span>` : ''}
                </p>
                <div style="display:flex;gap:0.75rem;justify-content:center;align-items:flex-end;">
                    <label style="display:flex;flex-direction:column;gap:4px;font-size:0.72rem;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:0.05em;">
                        Inicio
                        <input type="time" step="900" id="swal-class-start"
                               style="padding:8px 10px;border:1px solid #cbd5e1;border-radius:8px;font-size:0.95rem;" value="${targetClass.startTime || ''}">
                    </label>
                    <label style="display:flex;flex-direction:column;gap:4px;font-size:0.72rem;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:0.05em;">
                        Fin
                        <input type="time" step="900" id="swal-class-end"
                               style="padding:8px 10px;border:1px solid #cbd5e1;border-radius:8px;font-size:0.95rem;" value="${targetClass.endTime || ''}">
                    </label>
                </div>
                ${linked.length > 0 ? `
                    <label style="display:flex;align-items:center;gap:8px;justify-content:center;margin-top:1rem;font-size:0.78rem;color:#475569;">
                        <input type="checkbox" id="swal-apply-linked" checked>
                        Aplicar también a ${linked.length} formación${linked.length === 1 ? '' : 'es'} que comparte${linked.length === 1 ? '' : 'n'} esta clase
                        (${linked.map(l => Utils.sanitizeHTML(l.formationName)).join(', ')})
                    </label>
                ` : ''}
            `,
            width: '520px',
            showCancelButton: true,
            confirmButtonText: 'Guardar horario',
            cancelButtonText: 'Cancelar',
            focusConfirm: false,
            preConfirm: () => {
                const start = document.getElementById('swal-class-start').value;
                const end = document.getElementById('swal-class-end').value;
                if (!start || !end) {
                    Swal.showValidationMessage('Indica la hora de inicio y la de fin');
                    return false;
                }
                if (end <= start) {
                    Swal.showValidationMessage('La hora de fin debe ser posterior a la de inicio');
                    return false;
                }
                const applyLinked = linked.length > 0
                    ? document.getElementById('swal-apply-linked').checked
                    : false;
                return { start, end, applyLinked };
            }
        }).then(result => {
            if (!result.isConfirmed || !result.value) return;
            const { start, end, applyLinked } = result.value;
            this._applyTimeToSingleClass(classId, start, end, dateString, applyLinked ? linked.map(l => l.id) : []);
        });
    },

    _applyTimeToSingleClass(classId, startTime, endTime, dateString, linkedIds = []) {
        const targetClass = DataManager.getAll(DataManager.KEYS.CLASSES).find(c => c.id === classId);
        if (!targetClass) return;

        // Conflicto de profesor: misma franja, mismo día, otra clase
        if (targetClass.professorId) {
            const conflict = DataManager.checkProfessorConflict(
                targetClass.professorId, targetClass.dayOfWeek, startTime, endTime, dateString, classId
            );
            if (conflict.conflict) {
                Utils.showToast(conflict.message, 'error');
                return;
            }
        }

        DataManager.updateClass(classId, { startTime, endTime });
        linkedIds.forEach(id => DataManager.updateClass(id, { startTime, endTime }));

        Utils.showToast(
            linkedIds.length > 0
                ? `Horario cambiado a ${startTime}-${endTime} (y en ${linkedIds.length} formación${linkedIds.length === 1 ? '' : 'es'} más)`
                : `Horario cambiado a ${startTime}-${endTime} para este día`,
            'success'
        );

        this.updateLoadStatus();
        this.renderCalendar();
        this.renderSubjects();
        this.renderExtraSessions();

        const [y, m, d] = dateString.split('-').map(Number);
        this.showDayDetails(y, m - 1, d);
    },

    deleteClass(classId) {
        if (confirm('¿Seguro que deseas eliminar esta clase?')) {
            DataManager.deleteClass(classId);
            Utils.showToast('Clase eliminada', 'success');
            Utils.closeModal();
            this.renderCalendar();
        }
    },

    openNewSessionModal() {
        Utils.openModal('Nueva Sesión', `
    <p>Funcionalidad para crear nueva sesión en desarrollo...</p>
        `);
    },

    // ── Popup de información del aula (accesible para alumnos y admins) ────────
    showClassroomInfoPopup(classroomName, dateString, startTime, endTime) {
        // Load zones from storage
        const saved = BrowserState.getItem('ecpv_floorplan_zones');
        let zones = [
            { id: 'z1', name: 'Aula 1', floor: 1 },
            { id: 'z2', name: 'Aula 2', floor: 1 },
            { id: 'z3', name: 'Aula 3', floor: 1 },
            { id: 'z4', name: 'Aula 4', floor: 1 },
            { id: 'zp', name: 'Plató Principal', floor: 1 },
            { id: 'zs', name: 'Estudio de Sonido', floor: 1 },
            { id: 'ze', name: 'Sala de Edición', floor: 1 }
        ];
        if (saved) { try { zones = JSON.parse(saved); } catch(e) {} }

        // Find zone info
        const zone = zones.find(z => z.name.trim().toLowerCase() === classroomName.trim().toLowerCase());
        const floorLabel = zone ? (zone.floor === 2 ? '2ª Planta' : '1ª Planta') : '—';

        // Get all classes in this classroom on this date (all formations)
        const allClasses = DataManager.getAll(DataManager.KEYS.CLASSES) || [];
        const dayClasses = allClasses.filter(c =>
            c.classroom && c.classroom.trim().toLowerCase() === classroomName.trim().toLowerCase() &&
            c.startDate <= dateString && (c.endDate || c.startDate) >= dateString
        );

        // Format date for display
        const [y, m, d] = dateString.split('-');
        const months = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
        const formattedDate = `${parseInt(d)} de ${months[parseInt(m)-1]} ${y}`;

        // Build occupancy rows
        const occupancyRows = dayClasses.map(cls => {
            const subj = DataManager.getSubject(cls.subjectId);
            const form = DataManager.getFormation ? DataManager.getFormation(cls.formationId) : DataManager.getById(DataManager.KEYS.FORMATIONS, cls.formationId);
            const overlaps = startTime && endTime
                ? (cls.startTime < endTime && (cls.endTime || '23:59') > startTime)
                : true;
            const rowBg = overlaps ? 'rgba(239,68,68,0.07)' : 'rgba(248,250,252,1)';
            const timeBadgeBg = overlaps ? '#ef4444' : '#64748b';
            return `
                <div style="display:flex;align-items:center;gap:0.75rem;padding:0.6rem 0.75rem;border-radius:8px;background:${rowBg};border:1px solid #e2e8f0;margin-bottom:0.4rem;">
                    <span style="background:${timeBadgeBg};color:white;font-size:0.7rem;font-weight:700;padding:2px 7px;border-radius:5px;white-space:nowrap;">${cls.startTime||'?'}–${cls.endTime||'?'}</span>
                    <div style="flex:1;min-width:0;">
                        <div style="font-weight:700;font-size:0.85rem;color:#1e293b;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${subj ? Utils.sanitizeHTML(subj.name) : 'Asignatura'}</div>
                        <div style="font-size:0.72rem;color:#64748b;">${form ? Utils.sanitizeHTML(form.name) : 'Grupo desconocido'}</div>
                    </div>
                    ${overlaps ? '<span style="font-size:0.62rem;font-weight:800;color:#b91c1c;text-transform:uppercase;background:#fee2e2;padding:2px 6px;border-radius:4px;border:1px solid #fca5a5;">Coincide</span>' : ''}
                </div>`;
        }).join('');

        const isEmpty = dayClasses.length === 0;
        const statusColor = isEmpty ? '#10b981' : '#ef4444';
        const statusLabel = isEmpty ? 'Libre' : 'Ocupada';
        const statusIcon = isEmpty ? 'fa-check-circle' : 'fa-times-circle';

        SafeHTML.fire({
            title: `<span style="display:inline-flex;align-items:center;gap:8px;"><i class="fas fa-door-open" style="color:#3b82f6;"></i>${Utils.sanitizeHTML(classroomName)}</span>`,
            html: `
                <div style="text-align:left;">
                    <!-- Header info -->
                    <div style="display:flex;gap:0.75rem;align-items:center;margin-bottom:1rem;flex-wrap:wrap;">
                        <span style="background:#eff6ff;color:#2563eb;font-size:0.75rem;font-weight:700;padding:3px 10px;border-radius:6px;">
                            <i class="fas fa-building" style="margin-right:4px;"></i>${floorLabel}
                        </span>
                        <span style="background:${isEmpty ? '#f0fdf4' : '#fef2f2'};color:${statusColor};font-size:0.75rem;font-weight:700;padding:3px 10px;border-radius:6px;border:1px solid ${isEmpty ? '#bbf7d0' : '#fecaca'};">
                            <i class="fas ${statusIcon}" style="margin-right:4px;"></i>${statusLabel} — ${formattedDate}
                        </span>
                    </div>

                    ${isEmpty
                        ? `<div style="text-align:center;padding:1.5rem 0;color:#64748b;"><i class="fas fa-calendar-check" style="font-size:2rem;color:#10b981;display:block;margin-bottom:0.5rem;"></i>No hay clases programadas este día</div>`
                        : `<div style="font-size:0.78rem;font-weight:700;color:#475569;text-transform:uppercase;margin-bottom:0.5rem;letter-spacing:0.04em;">Clases programadas</div>${occupancyRows}`}

                    <!-- Link to full map -->
                    <div style="margin-top:1rem;text-align:center;">
                        <button ${UIEvents.attr("click", function(event,captured){Swal.close();App.navigate('mapa-interactivo');}, [])} style="display:inline-flex;align-items:center;gap:0.4rem;background:linear-gradient(135deg,#2563eb,#0ea5e9);color:white;border:none;border-radius:8px;padding:7px 16px;font-size:0.8rem;font-weight:700;cursor:pointer;box-shadow:0 2px 8px rgba(37,99,235,0.25);">
                            <i class="fas fa-map-marked-alt"></i> Ver plano completo
                        </button>
                    </div>
                </div>
            `,
            width: '480px',
            showConfirmButton: false,
            showCancelButton: true,
            cancelButtonText: 'Cerrar'
        });
    }
});
